<script lang="ts">
	import { openModal } from '$lib/stores/modal';
	import { reveal } from '$lib/actions/reveal';
	import { magnetic } from '$lib/actions/magnetic';
	import StatusDot from '$lib/components/ui/StatusDot.svelte';

	interface Props {
		eyebrow?: string;
		eyebrowDot?: boolean;
		title: string;
		titleHtml?: string;
		description?: string;
		primaryLabel?: string;
		secondaryLabel?: string;
		secondaryHref?: string;
	}
	let {
		eyebrow = 'Limited Design Partner Slots',
		eyebrowDot = true,
		title,
		titleHtml,
		description = "We work hand-in-hand with a small group of forward-thinking teams. If you're building something ambitious at the edge, we'd love to talk.",
		primaryLabel = 'Partner with us',
		secondaryLabel = 'Explore the docs',
		secondaryHref = 'https://docs.admrl.co'
	}: Props = $props();
</script>

<section class="mx-auto mt-20 max-w-[1216px] px-4 sm:mt-32 lg:mt-40 lg:px-0">
	<div
		class="gradient-border reveal relative flex flex-col items-center overflow-hidden rounded-2xl p-6 text-center sm:p-10 lg:p-20"
		use:reveal
	>
		<div class="subtle-glow absolute inset-0 -z-10"></div>
		{#if eyebrow}
			<span
				class="badge-eyebrow mb-6 inline-flex items-center gap-2 rounded-md px-3 py-1.5 font-display text-[11px] font-medium uppercase tracking-[0.18em]"
			>
				{#if eyebrowDot}<StatusDot />{/if}
				{eyebrow}
			</span>
		{/if}
		<h2
			class="text-gradient-enterprise max-w-3xl font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-4xl lg:text-6xl"
		>
			{#if titleHtml}{@html titleHtml}{:else}{title}{/if}
		</h2>
		<p class="mt-6 max-w-xl font-display text-base text-white/65 sm:text-lg">
			{description}
		</p>
		<div class="mt-8 flex w-full flex-col justify-center gap-3 sm:mt-10 sm:w-auto sm:flex-row">
			<button
				use:magnetic
				onclick={openModal}
				class="btn-primary inline-flex h-12 items-center justify-center rounded-md px-7 font-display text-sm font-medium"
			>
				{primaryLabel}
			</button>
			<a
				use:magnetic
				href={secondaryHref}
				target="_blank"
				rel="noopener"
				class="btn-secondary inline-flex h-12 items-center justify-center rounded-md px-7 font-display text-sm font-medium"
			>
				{secondaryLabel}
			</a>
		</div>
	</div>
</section>
